import {Route} from 'vue-router';
import store from '../store';
import cookies from 'js-cookie';
import { SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN} from '@/const/words/cookie';
import {refreshToken} from '@/utils/dataUtils';
import JwtDecode from 'jwt-decode';
import {Admin} from '@/types';
import metaTitles from '@/const/words/metaTitle';
import { sanitizeRedirectPath } from '@/utils/sanitizeRedirectPath';
// to: Route,
// from: Route,
// next: (to?: RawLocation | false | ((vm: V) => any) | void) => void

// 라우터 이동직전에 현재 실행되는 로딩바 클로즈 처리
export function closeDimmedArea(to: Route, from: Route, next: () => void): void {
  store.commit('SET_DIMMEDAREASWITCH', true);
  next();
}

export function openDimmedArea() {
  store.commit('SET_DIMMEDAREASWITCH', false);
}

export function checkLogin(to: Route, from: Route, next: any): void {
  if (!to.meta.nonMember) {
    const accessToken = cookies.get(SHOPBY_ACCESSTOKEN);
    if (accessToken) {
      let admin: Admin = null;
      try {
        admin = JwtDecode(accessToken);
      } catch {
        alert(window.$t('COMMON_SERVER_ERROR_MSG'));
        //(임시-추후 복원)레거시 로그인 페이지로 이동을 위해
        next('/login');
        // window.location.href = '/login';
      }

      const changedAdmin = !store.state.admin.admin || admin.no !== store.state.admin.admin.no;
      if (changedAdmin) {
        store.dispatch('admin/setAdmin', admin);
      }
      store.dispatch('mall/fetchMalls', changedAdmin).then((): any => {
        // store.dispatch('admin/fetchMyManageInfo', changedAdmin).then((): any => {
        store.dispatch('admin/fetchMainMenus', changedAdmin).then((): any => {
          next();
        });
        // });
      });
    } else {
      const refreshCode = cookies.get(SHOPBY_REFRESHTOKEN);
      if (refreshCode && refreshCode.length) {
        const oldAdminNo = store.state.admin.admin ? store.state.admin.admin.no : -1;
        refreshToken().then((refreshFlg: boolean): void => {
          if (refreshFlg) {
            const changedAdmin = store.state.admin.admin.no !== oldAdminNo;
            store.dispatch('mall/fetchMalls', changedAdmin).then((): any => {
              // store.dispatch('admin/fetchMyManageInfo', changedAdmin).then((): any => {
              store.dispatch('admin/fetchMainMenus', changedAdmin).then((): any => {
                next();
              });
              // });
            });
          } else {
            next('/error-page/unauthorized');
          }
        });
      } else {
        alert('엑세스 토큰이 만료되었습니다. 토큰을 갱신하거나 다시 로그인해주세요')
        //(임시-추후 복원)레거시 로그인 페이지로 이동을 위해
        next(`/login?redirectUrl=${encodeURIComponent(sanitizeRedirectPath(to.fullPath))}`);
        // window.location.href = '/login';
      }
    }
  } else {
    next();
  }
}

// 몰이 설정되지 않았을경우
export function notMallService(to: Route, from: Route, next: any): void {
  if (to.name === 'MallList' || to.name === 'MallAddForm' || to.name === 'Main' || to.meta.nonMember) {
    next();
  } else {
    const stateMalls = store.state.mall.malls;
    const accessToken = cookies.get(SHOPBY_ACCESSTOKEN);
    if (!(accessToken && !stateMalls.length)) {
      next();
    }
  }
}
export function initState(to: Route, from: Route, next: any): void {
  store.commit('SET_PREVIOUS_PATH', from.fullPath);
  next();
}
const excludeChangeDocTitleList = ['EditProduct', 'CopyProduct'];
export function changeDocTitle({name}: Route): void {
  jQuery(($): void => {
    setTimeout((): void => {
      if (!excludeChangeDocTitleList.includes(name)) {
        const $pageTitle = $('.page_tit:visible');
        if ($pageTitle.length) {
          $(document).attr('title', $pageTitle[0].firstChild ? $pageTitle[0].firstChild.textContent : $pageTitle.text());
        } else {
          if (!name) return;
          const titleItem = metaTitles.find((item: any): boolean => item.code === name);
          if (titleItem) {
            $(document).attr('title', titleItem.values[window.$i18n.locale]);
          }
        }
      }
    }, 1000);
  });
}
